module.exports = __webpack_public_path__ + "static/media/ELA.c82a7afd.svg";